import { defineComponent as _defineComponent } from 'vue'
import 
TUIChatEngine,
{
  TUIStore,
  TUIGlobal,
  StoreName,
  IConversationModel,
  TUITranslateService,
  TUIConversationService,
} from "@tencentcloud/chat-uikit-engine";
import {
  computed,
  ref,
  defineProps,
  onMounted,
  nextTick,
  getCurrentInstance,
} from "../../adapter-vue";
import ConversationList from "./conversation-list/index.vue";
import TUISearch from "../TUISearch/index.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  displayOnlineStatus: {
    type: Boolean,
    default: true,
  },
},
  emits: ["handleSwitchConversation"],
  setup(__props, { emit: emits }) {

const props = __props




const list = ref();
const totalUnreadCount = ref(0);
const netWork = ref("");
// const listRectInfo = ref({});
const isH5 = ref(TUIGlobal.getPlatform() === "h5");
const isApp = ref(TUIGlobal.getPlatform() === "app");
const isWeChat = ref(TUIGlobal.getPlatform() === "wechat");
const isUniFrameWork = ref(typeof uni !== 'undefined');

TUIStore.watch(StoreName.CONV, {
  totalUnreadCount: (count: number) => {
    totalUnreadCount.value = count;
  },
});

const isNetwork = computed(() => {
  const disconnected = netWork.value === TUIChatEngine.TYPES.NET_STATE_DISCONNECTED;
  const connecting = netWork.value === TUIChatEngine.TYPES.NET_STATE_CONNECTING;
  return disconnected || connecting;
});

const handleSwitchConversation = (conversationID: string) => {
  if (isUniFrameWork.value)
    uni.navigateTo({
    url: '/TUIKit/components/TUIChat/index',
  });
  emits("handleSwitchConversation", conversationID);
};

const getListRectInfo = (e: any) => {
  if (isApp.value || isWeChat.value) {
    const query = (uni as any)?.createSelectorQuery();
    query
      .select(".list")
      .boundingClientRect((data: any) => {
        list?.value?.setListRectInfo(data);
      })
      .exec();
  }
};

return { __sfc: true,props, emits, list, totalUnreadCount, netWork, isH5, isApp, isWeChat, isUniFrameWork, isNetwork, handleSwitchConversation, getListRectInfo, TUITranslateService, ConversationList, TUISearch }
}

})